// const staging = `http://34.101.196.56/`;
// const production = `http://34.101.196.56/`;
// export const BaseUrlRace = `http://34.101.196.56/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;

// const staging = `https://api.eurekalogistics.co.id/`;
// const production = `https://api.eurekalogistics.co.id/`;
// export const BaseUrlRace = `https://api.rajacepat.com/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;

const staging = `https://stagingapi.eurekalogistics.co.id/`;
const production = `https://api.eurekalogistics.co.id/`;
export const BaseUrlRace = `https://apirace.eurekalogistics.co.id/`;
const Baseurl = production;
// const Baseurl = process.env.REACT_APP_API_URL;
export default Baseurl;

// const staging = `https://api.rajacepat.com`;
// const production = `https://api.rajacepat.com`;
// export const BaseUrlRace = `https://api.rajacepat.com/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;

// const staging = `http://localhost:2025/`;
// const production = `http://localhost:2025/`;
// export const BaseUrlRace = `http://localhost:2025/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;

